export enum ActionDescriptor {
  CreateCatalogOrder = 1,
  CreateTMOrder = 2,
  UpdateCatalogOrder = 3,
  UpdateTMOrder = 4,
  CreateClient = 5,
  UpdateClient = 6,
  LearningResourcesUploadVideo = 7,
  LearningResourcesUploadUserGuide = 8,
  ClientOpenAccess = 9,
  ClientArchive = 10,
  ClientDeactivateAccountAndScheduleAnonymize = 11,
  ClientDeactivateAccountAndImmediateAnonymize = 12,
  ClientResetPassword = 13,
  TenantSaveModifications = 14,
  TenantSaveWorkLoad = 15,
  UnAssignUserRole = 16,
  CreateCategories = 17,
  DeleteVideo = 18,
  DeleteUserGuide = 19,
  CreateScope = 20,
  RestoreClientAccount = 21,
  AssignUserRole = 22,
  CatalogArchive = 23,
  CatalogDelete = 24,
  TermsAndConditionAcceptance = 25,
  AddDeliverable = 26,
  ModifyDeliverable = 27,
  DeliverableSubmission = 28,
  DeliverableCancelSubmission = 29,
  DeliverableDMValidationAccept = 30,
  DeliverableDMValidationRefuse = 31,
  DeliverableDMValidationReserve = 32,
  DeliverableValidationCancel = 33, // DeliverableSubmission
  DeliverableClientAccept = 34,
  DeliverableClientRefuse = 35,
  DeliverableClientReserve = 36,
  DeliverableRating = 37,
  DeliverableCancelAssessment = 38,
  DeliverableCancelAcceptance = 39,
  DeliverableCancellation = 40,
  CreateTechnicalReport = 41,
  CreateFinancialReport = 42,
  SendToClient = 43,
  MarkAsSigned = 44,
  AuthLogin = 45,
  AuthLogout = 46,
  ClientSigned = 47,
  DeliverableBulkRestore = 48,
}
